import React, { FunctionComponent } from "react";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../types/IContentfulImage";
import "./styles.scss";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export interface IAuthorByLineProps {
  heading?: string;
  name: string;
  title?: string;
  image: IContentfulImage & ImageDataLike;
  url?: string;
}

export const AuthorBylineText: FunctionComponent<Partial<IAuthorByLineProps>> = ({
  heading,
  name,
  title,
}) => (
  <>
    <div className="author-byline_heading">{heading}</div>
    <div className="author-byline_name">{name}</div>
    <div className="author-byline_title">{title}</div>
  </>
);

export const AuthorBylineImage: FunctionComponent<{
  image: IContentfulImage & ImageDataLike;
  url?: string;
}> = ({ image, url }) => (url ? (
  <a href={url}>
    <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} className="author-byline_image" />
  </a>
) : (
  <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} className="author-byline_image" />
));

export const AuthorByline: FunctionComponent<IAuthorByLineProps> = (props) => {
  const { image, url, ...rest } = props;

  return (
    <div
      className="author-byline_container"
      role="region"
      aria-label="Author information"
    >
      <AuthorBylineImage image={image} url={url} />
      {url ? (
        <a href={url} className="author-byline_text">
          <AuthorBylineText {...rest} />
        </a>
      ) : (
        <div className="author-byline_text">
          <AuthorBylineText {...rest} />
        </div>
      )}
    </div>
  );
};
